/* eslint-disable no-invalid-this */
function ifFn(logicalValue, trueValue, falseValue) {
  if (logicalValue.toString() === "true") {
    return trueValue;
  }
  return falseValue;
}

export default ifFn;
